import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAnswersByUser } from "../../store/dashboardSlice";
import { likeAnswer } from "../../store/queriesAnswerSlice";
import {
  Box,
  Typography,
  Avatar,
  FormControl,
  Select,
  MenuItem,
  Tooltip,
} from "@mui/material";
import { useMsal } from "@azure/msal-react";
import { getPostedTime } from "../HomeFolder/QA";
import { useNavigate } from "react-router-dom";

const QueriesAnswered = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { accounts } = useMsal();
  const loggedInUserId = accounts?.[0]?.idTokenClaims?.oid;

  const { answeredList, answersLoading } = useSelector(
    (state) => state.dashboard
  );

  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  useEffect(() => {
    if (loggedInUserId) {
      dispatch(fetchAnswersByUser(loggedInUserId));
    }
  }, [dispatch, loggedInUserId]);

  const totalPages = Math.ceil(answeredList.length / rowsPerPage);

  const paginatedData = answeredList.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  if (answersLoading) {
    return (
      <Box sx={{ mt: 6, textAlign: "center" }}>
        <Typography>Loading...</Typography>
      </Box>
    );
  }

  if (!answersLoading && answeredList.length === 0) {
    return (
      <Box sx={{
        textAlign: "center",
        mt: 6,
        p: 4,
        border: "1px dashed #B980DF",
        backgroundColor: "#faf5ff",
      }}>
        <Typography sx={{ color: "#7500C0", fontWeight: 600 }}>
          You haven't answered any queries yet.
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      {paginatedData.map((item) => (
        <Box
          key={item.answerid}
          sx={{
            border: "1px solid #B980DF",
            p: 2,
            paddingLeft: 0,
            mb: 2,
            display: "flex",
            gap: 2,
            overflowWrap: "anywhere",
            wordBreak: "normal" ,
            minWidth: 0
          }}
        >
          <Box
            sx={{
              width: 6,
              backgroundColor: "#7500C0",
              height: 40,
            }}
          />

          <Box sx={{ flex: 1 }}>
            <Box sx={{ display: "flex", alignItems: "flex-start", mb: 1 }}>
              <Avatar sx={{ width: 36, height: 36, mr: 1.5 }} />

              <Box>
                <Typography fontWeight={600}>
                  {item.question_username}
                </Typography>
                <Typography variant="caption" color="#818180">
                  {item.question_designation}
                </Typography>
              </Box>

              <Typography
                variant="caption"
                color="#757575"
                sx={{ ml: "auto" }}
              >
                Posted {getPostedTime(item.question_created_at)}
              </Typography>
            </Box>

            <Typography className="question_typo"
              sx={{
                color: "#7500C0",
                fontWeight: 600,
                mb: 1,
                fontSize: "14px",
                cursor: "pointer",
              }}
              onClick={() =>
                navigate(`/queries/${item.question_id}`)
              }
            >
              {item.question_body}
            </Typography>

            <Box sx={{ display: "flex", gap: 1.5, mb: 1.5 }}>
              <Avatar sx={{ width: 36, height: 36 }} />

              <Box
                sx={{
                  backgroundColor: "#F1F1EF",
                  p: 1,
                  flex: 1,
                  border: "1px solid #9D9D9B",
                }}
              >
                <Typography sx={{ fontSize: "14px" }}>
                  {item.answer}
                </Typography>
              </Box>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                gap: 1.5,
              }}
            >
              {item.is_best_answer === 1 && (
                <Box className="actionItem" sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                  <input
                    type="checkbox"
                    checked
                    readOnly
                    className="circleCheckbox"
                  />
                  <Typography sx={{ fontSize: "13px" }}>
                    Best Answer
                  </Typography>
                </Box>
              )}

              <Box className="actionItem"
                sx={{ display: "flex",alignItems: "center", gap: 0.5, cursor: "pointer" }}
                onClick={() =>
                  dispatch(likeAnswer({ answer: item }))
                }
              >
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/Home/like.png"
                  }
                  alt="Like"
                  className="qaActionIcon"
                />
                <Typography variant="body2">
                  {item.likes_count || 0}
                </Typography>
              </Box>
                <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}

              >
                <img
                  src={process.env.PUBLIC_URL + "/images/Home/dot_img.png"}
                  alt="dot"

                />
              </Box>
              <Tooltip
                title="Views"
                arrow
                classes={{
                  tooltip: "custom-tooltip",
                  arrow: "custom-tooltip-arrow",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                    cursor: "pointer",
                  }}
                >
                  <Box
                   component="img"
                    src={
                      process.env.PUBLIC_URL +
                      "/images/Home/view.png"
                    }
                    alt="views"
                    sx={{
                      width: 16,
                      height: 16,
                      transition: "0.2s ease",
                      "&:hover": {
                        content: `url(${process.env.PUBLIC_URL + "/images/Home/Visible.png"})`,
                      },
                    }}
                  />
                  <Typography variant="body2"color="#9D9D9B">
                    {item.views}
                  </Typography>
                </Box>
              </Tooltip>
            </Box>
          </Box>
        </Box>
      ))}

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: 1,
          mt: 4,
        }}
      >
      <Box
          onClick={() => page > 1 && setPage(page - 1)}
          sx={{
            cursor: page > 1 ? "pointer" : "not-allowed",
          }}
        >
          <img
            src={
              page > 1
                ? process.env.PUBLIC_URL + "/images/Home/leftenabledArrow.png"
                : process.env.PUBLIC_URL + "/images/Home/leftdisabledArrow.png"
            }
            alt="Previous"
            style={{ width: 32, height: 32 }}
          />
        </Box>
        <Box sx={{ display: "flex", gap: 1 }}>
          {[...Array(totalPages)].map((_, i) => (
            <Typography
              key={i}
              onClick={() => setPage(i + 1)}
              sx={{
                cursor: "pointer",
                fontWeight: page === i + 1 ? 600 : 400,
                color: page === i + 1 ? "#7500C0" : "#000",
                borderBottom:
                  page === i + 1 ? "2px solid #7500C0" : "none",
                px: 1,
              }}
            >
              {i + 1}
            </Typography>
          ))}
        </Box>
        <Box
          onClick={() => page < totalPages && setPage(page + 1)}
          sx={{
            cursor: page < totalPages ? "pointer" : "not-allowed",
          }}
        >
          <img
            src={
              page < totalPages
                ? process.env.PUBLIC_URL + "/images/Home/rightenabledArrow.png"
                : process.env.PUBLIC_URL + "/images/Home/rightdisabledArrow.png"
            }
            alt="Next"
            style={{ width: 32, height: 32 }}
          />
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1, ml: 2 }}>
          <Typography sx={{ fontSize: "14px" }}>
            Items per page
          </Typography>
          <FormControl size="small">
            <Select
              value={rowsPerPage}
              onChange={(e) => {
                setRowsPerPage(e.target.value);
                setPage(1);
              }}
              sx={{
                width: 70,
                "& .MuiOutlinedInput-notchedOutline": {
                  borderRadius: "0px",
                },
              }}
            >
              <MenuItem value={5}>5</MenuItem>
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={20}>20</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </Box>
    </Box>
  );
};

export default QueriesAnswered;